"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckPermissions = void 0;
const react_1 = require("react");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const useCheckPermissions = () => {
    const { fn } = (0, react_hooks_1.useApiCall)((api, values) => api.fetchJson({
        url: "/access-control",
        data: values,
    }), { success: false, error: false });
    const checkPermissions = (0, react_1.useCallback)(async (value) => {
        const { address, account } = value;
        return fn(void 0, { account, address });
    }, []);
    return { checkPermissions };
};
exports.useCheckPermissions = useCheckPermissions;
//# sourceMappingURL=use-check-permissions.js.map